import { CustomValidatorArgs } from '../types/CSVTypes';
import { handleSeparatingPackages } from '../helpers/handleSeperatingPackage';

const barcodeValidator = ({ value }: CustomValidatorArgs) => {
  if (!value || value.trim() === '') {
    return null;
  }

  // Parse the CSV string into individual barcodes
  const barcodes = handleSeparatingPackages(String(value));

  // Check each barcode individually
  for (const barcodeObj of barcodes) {
    if (barcodeObj.barcode.length > 128) {
      return 'invalidBarcode';
    }
  }

  return null;
};

export default barcodeValidator;
